import React, { forwardRef, useLayoutEffect } from 'react';
import { use100Vh } from '@growth/custom-hooks/use100Vh';
import { useHasMounted } from '@growth/custom-hooks/useHasMounted';
import styled, { keyframes } from 'styled-components';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var btmSheetSlideUp = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  0% {\n    transform: translateY(calc(var(--100vh) - 34px));\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n"])));
var BottomSheet$1 = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  background: #fff;\n  border-radius: 20px 20px 0 0;\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  ", "\n\n  z-index: 1024;\n  animation: ", " 0.3s ease-in-out forwards;\n\n  .gr-bodyFixed {\n    overflow: hidden;\n  }\n"])), function (props) {
  return props.isFull ? 'height: var(--100vh);' : 'max-height: calc(var(--100vh) - 34px);';
}, btmSheetSlideUp);
var BottomSheetCont = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  overflow: auto;\n"])));
var SheetClose = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  padding: 14px;\n\n  &::before,\n  &::after {\n    position: absolute;\n    content: ' ';\n    height: 17px;\n    width: 2px;\n    background-color: #475b78;\n  }\n\n  &::before {\n    transform: rotate(45deg);\n  }\n\n  &::after {\n    transform: rotate(-45deg);\n  }\n"])));
var BottomSheetOverlay = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  touch-action: none;\n  width: 100%;\n  height: 100%;\n  ", "\n\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 1023;\n"])), function (props) {
  return props.isFull ? 'background: rgb(227 227 227 / 80%);' : 'background: rgba(0, 0, 0, 0.8);;';
});

var BottomSheet = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var closeBtn = _ref.closeBtn,
      children = _ref.children,
      onClose = _ref.onClose,
      _ref$fullSheet = _ref.fullSheet,
      fullSheet = _ref$fullSheet === void 0 ? false : _ref$fullSheet,
      shouldCloseOutSideClick = _ref.shouldCloseOutSideClick;

  var _use100Vh = use100Vh(),
      set100VhCssVar = _use100Vh[0];

  var clientOnly = useHasMounted();
  useLayoutEffect(function () {
    // set --100vh on css root var for bottom sheet height css
    set100VhCssVar(); // fixed scrolling when bottom sheet is opened

    document.body.style.overflow = 'hidden';
    return function () {
      document.body.style.removeProperty('overflow');
    };
  }, []);
  return clientOnly ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BottomSheet$1, {
    ref: ref,
    isFull: fullSheet
  }, closeBtn && /*#__PURE__*/React.createElement(SheetClose, {
    onClick: function onClick() {
      return onClose('x-click');
    }
  }), /*#__PURE__*/React.createElement(BottomSheetCont, null, children)), /*#__PURE__*/React.createElement(BottomSheetOverlay, {
    isFull: fullSheet,
    onClick: shouldCloseOutSideClick ? function () {
      return onClose('outside-click');
    } : function () {}
  })) : null;
});
BottomSheet.displayName = 'BottomSheet';
BottomSheet.defaultProps = {
  closeBtn: true
};

export { BottomSheet as default };
